import store from "@/store";

// if have token, try to preload data
export const preloadRequiredData =  async () => {
    const token = store.getters["auth/selectToken"];
    if (!token) {
      return;
    }
    // Fetch glossary and settings in parallel (they're independent)
    await Promise.all([
      store.dispatch("getGlossary"),
      store.dispatch("getSettings")
    ]);

    // Then fetch other data in parallel
    await Promise.all([
      store.dispatch("auth/getUserData"),
      store.dispatch("shiftService/getShift"),
      store.dispatch("officeService/getOffices"),
      store.dispatch("servicesService/loadAll"),
      store.dispatch("shiftService/getShift")
    ]);
  };